// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Stack, Typography } from '@mui/material';

interface TriageInfoRowProps {
  label: string;
  value: string | null;
}

export function TriageInfoRow(props: TriageInfoRowProps) {
  return (
    <Stack gap={1} direction="row">
      <Typography variant="subtitle2" sx={{ minWidth: 100 }}>
        {props.label}:
      </Typography>
      <Typography
        variant="body2"
        color={props.value ? 'text.primary' : 'text.secondary'}
      >
        {props.value || '\u2014'}
      </Typography>
    </Stack>
  );
}
